import { useQuery } from '@tanstack/react-query';
import { getTwitterAccount } from '../twitter.service';
export const useTwitterAccount = (username, options) => useQuery({
    queryKey: ['twitter', username],
    queryFn: () => getTwitterAccount(username),
    enabled: options?.enabled ?? !!username,
});
